import { Pen, TriangleAlert } from 'lucide-react'
import { useTranslation } from 'next-i18next'
import { useState } from 'react'
import { Button } from '~/components/ui/button'
import {
	Dialog,
	DialogContent,
	DialogHeader,
	DialogTitle,
	DialogTrigger,
} from '~/components/ui/dialog'
import { AddressFactuForm } from '~/domains/account/components/personal-infos/infos-factu-form'
import { useUserContext } from '~/providers/user-provider'

const Error = () => {
	const { t } = useTranslation()

	return (
		<div className='flex min-w-0 flex-col items-center gap-1 text-center text-primary text-sm'>
			<TriangleAlert
				size={24}
				strokeWidth={1.5}
			/>

			{t('errors:user.factuInfosIncomplete')}
		</div>
	)
}

const FactuInfos = () => {
	const { accountQuery } = useUserContext()

	const { postal_code, city, country, company, address } =
		accountQuery.data?.billing_address || {}

	const fullAddress = `${postal_code || ''} ${city || ''}, ${country || ''}`

	return (
		<div className='min-w-0 text-sm'>
			<div className='truncate font-bold'>{company || ''}</div>

			<div className='truncate'>{address || ''}</div>

			<div className='truncate'>{fullAddress}</div>
		</div>
	)
}

export const FactuInfosRecap = ({
	readOnly = false,
}: { readOnly?: boolean }) => {
	const { t } = useTranslation()
	const { isInfoFactuIncomplete } = useUserContext()

	const [isOpen, setIsOpen] = useState(false)

	return (
		<div className='flex flex-col gap-1'>
			{isInfoFactuIncomplete ? <Error /> : <FactuInfos />}

			{!readOnly && (
				<div className='mt-auto flex flex-row print:hidden'>
					<Dialog
						open={isOpen}
						onOpenChange={setIsOpen}
					>
						<DialogTrigger asChild>
							<Button
								variant='link'
								size='sm'
								className='ml-auto'
							>
								<Pen
									size={14}
									className='mr-1'
								/>

								{t('actions:update.btnLabel')}
							</Button>
						</DialogTrigger>

						<DialogContent>
							<DialogHeader>
								<DialogTitle>{t('billingAddressForm:title')}</DialogTitle>
							</DialogHeader>

							<AddressFactuForm onSuccess={() => setIsOpen(false)} />
						</DialogContent>
					</Dialog>
				</div>
			)}
		</div>
	)
}
